import * as React from 'react';
import { UIHeading1, UIText1, UIText2 } from '@cian/ui-kit';

import * as styles from './TermsInfo.css';

export interface ITermsInfoProps {
  contacts: React.ReactNode;
  priceFrom?: string;
  priceSquareFrom?: string;
  saleDescription?: string;
  workTime?: string;
}

export const TermsInfo: React.FC<ITermsInfoProps> = ({
  contacts,
  priceFrom,
  priceSquareFrom,
  saleDescription,
  workTime,
}) => {
  return (
    <div className={styles['container']} data-testid="TermsInfo">
      {priceFrom && <UIHeading1 as="p">{priceFrom}</UIHeading1>}
      {priceSquareFrom && (
        <div className={styles['price-square']}>
          <UIText1 as="p">{priceSquareFrom}</UIText1>
        </div>
      )}
      {saleDescription && (
        <div className={styles['description']}>
          <UIText2 as="p">{saleDescription}</UIText2>
        </div>
      )}
      {contacts}
      {workTime && (
        <div className={styles['work-time']}>
          <UIText2 as="p" color="text-secondary-default">
            {workTime}
          </UIText2>
        </div>
      )}
    </div>
  );
};
